import { render, staticRenderFns } from "./ScorekeeperLayout.vue?vue&type=template&id=2561326d"
import script from "./ScorekeeperLayout.vue?vue&type=script&lang=js"
export * from "./ScorekeeperLayout.vue?vue&type=script&lang=js"
import style0 from "./ScorekeeperLayout.vue?vue&type=style&index=0&id=2561326d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports